var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.number !== null)?_c(_vm.tag,{tag:"component",staticClass:"my-6 block text-primary text-lg md:text-xl lg:text-2xl leading-extra-tight",attrs:{"href":_vm.href}},[_vm._v(" "+_vm._s(_vm.number)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }